import { FC, useState } from "react";
import { WalletConnectDialog } from "@/components/WalletConnect/WalletConnectDialog";
import { DepositStepHeader } from "./DepositStepHeader";

interface ConnectStepProps {
  onBack?: () => void;
}

export const ConnectStep: FC<ConnectStepProps> = ({ onBack }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      {/* Header */}
      <DepositStepHeader
        title="Connect your wallet"
        description="Connect a Cardano wallet to fund your Sugar Rush deposit."
      />

      {/* Wallet illustration */}
      <div className="sr-card w-full p-4 sm:p-6 flex flex-col items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-sr-surface-raised flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="6" width="20" height="14" rx="2" stroke="var(--color-sr-pink-light)" strokeWidth="1.5" />
            <path d="M2 10H22" stroke="var(--color-sr-pink-light)" strokeWidth="1.5" />
            <circle cx="17" cy="14.5" r="1.5" fill="var(--color-sr-lemon-muted)" />
          </svg>
        </div>
        <p className="text-sm text-sr-neutral-500 text-center">
          We support all major Cardano wallets including Eternl, Lace, Nami, and more.
        </p>
      </div>

      {/* Legal disclaimer */}
      <div className="sr-highlight-box w-full">
        <div className="flex flex-col gap-1.5">
          <p className="text-base font-medium text-sr-pink-light">
            Legal Disclaimer
          </p>
          <p className="text-xs text-sr-pink-bright">
            By connecting a wallet, you agree to the Official Competition
            Rules. You will be asked to confirm your agreement, and to verify
            your identity with X, before your deposit is submitted.
          </p>
        </div>
      </div>

      {/* CTA */}
      <div className="flex w-full items-center gap-3">
        {onBack && (
          <button
            className="sr-surface-pill flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-full text-sr-neutral-300 transition-colors hover:text-white"
            onClick={onBack}
            aria-label="Go back"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        )}
        <button
          className="sr-btn-primary flex-1"
          onClick={() => setDialogOpen(true)}
        >
          Connect wallet
        </button>
      </div>

      <WalletConnectDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
